var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileAppStars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 27,
    viewBox: "0 0 135 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0804 0L17.2417 9.32827H27.4717L19.1954 15.0935L22.3567 24.4217L14.0804 18.6565L5.80415 24.4217L8.9654 15.0935L0.689144 9.32827H10.9192L14.0804 0Z",
    fill: "#FFCD41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2415 0L45.4028 9.32827H55.6328L47.3565 15.0935L50.5178 24.4217L42.2415 18.6565L33.9653 24.4217L37.1265 15.0935L28.8503 9.32827H39.0803L42.2415 0Z",
    fill: "#FFCD41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.4022 0L73.5634 9.32827H83.7934L75.5172 15.0935L78.6784 24.4217L70.4022 18.6565L62.1259 24.4217L65.2872 15.0935L57.0109 9.32827H67.2409L70.4022 0Z",
    fill: "#FFCD41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5631 0L101.724 9.32827H111.954L103.678 15.0935L106.839 24.4217L98.5631 18.6565L90.2868 24.4217L93.4481 15.0935L85.1718 9.32827H95.4018L98.5631 0Z",
    fill: "#FFCD41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.724 0L129.885 9.32827H131.839L131.839 15.0935L135 24.4217L126.724 18.6565L118.448 24.4217L121.609 15.0935L113.333 9.32827H123.563L126.724 0Z",
    fill: "#FFCD41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppStars);
export default __webpack_public_path__ + "static/media/mobile_app_stars.2861e22bcba15a746dc29d62873a08db.svg";
export { ForwardRef as ReactComponent };